<template>
    <v-form v-model="valid" ref="areasComunes" lazy-validation>
        <v-row>
            <v-col cols="12" sm="6">
                <v-autocomplete label="Portería"
                                :items="portersLodge"
                                clearable
                                :rules="[rules.required]">
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6">
                <v-autocomplete label="Ascensor"
                                :items="elevator"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12">
                <v-combobox label="Áreas comunes"
                            :items="commonAreas"
                            deletable-chips
                            chips
                            multiple
                            clearable>
                </v-combobox>
            </v-col>

            <v-col cols="12">
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="abadPrimary" @click="submit">Continuar</v-btn>
                </v-card-actions>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import constants from '@/pages/RealEstate/libs/constants.js'
import rules from '@/libs/rules'
export default {
  data () {
    return {
      commonAreas: constants.commonAreas,
      elevator: constants.elevator,
      portersLodge: constants.portersLodge,
      rules,
      valid: true
    }
  },
  methods: {
    submit () {
      const stateForm = this.$refs.areasComunes.validate()
      this.$emit('updateStateForm', stateForm)
      if (!stateForm) return

      console.log('estoy aqui')
    }
  }
}
</script>
